import { color } from '@wrongstack/core';

export const theme = {
  primary: color.amber,
  accent: color.pink,
  muted: color.dim,
  success: color.green,
  warn: color.yellow,
  error: color.red,
  info: color.cyan,
  bold: color.bold,
  underline: color.underline,
};
